export default __webpack_public_path__ + "static/media/chat.7d92a539.png";